<tabs-inner-wrap>
  <guided-simulation-information [simulationDetails]="simulationDetails"></guided-simulation-information>
</tabs-inner-wrap>
